import { Image, Link, Box } from '@packages/shared';
import { useConfig, useCookies } from '@packages/utilities';
import { useIntl } from 'react-intl';

const Seal = ({ link, imageSrc, alt }: { link: string; imageSrc: string; alt: string }) => (
  <Link href={link} target="_blank">
    <Image src={imageSrc} alt={alt} width={75} height={75} unoptimized />
  </Link>
);

export const Seals = () => {
  const {
    order: { seals, assets: images },
  } = useConfig();
  const { getCookies } = useCookies();
  const { appView } = getCookies();

  const { locale } = useIntl();
  const language = locale.split('-')[0];

  if (appView === 'true') {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        py: 2,
        px: { xs: 2, md: 0 },
        width: '100%',
        bgcolor: 'common.white',
      }}
    >
      {seals.trustedShops.enabled && (
        <Seal
          link={seals.trustedShops.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'trustedShops' })}
          alt="trustedShops"
        />
      )}
      {seals.ehi.enabled && (
        <Seal
          link={seals.ehi.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'ehi' })}
          alt="ehi"
        />
      )}
      {seals.staatswappen.enabled && (
        <Seal
          link={seals.staatswappen.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'staatswappen' })}
          alt="staatswappen"
        />
      )}
      {seals.handelsverband.enabled && (
        <Seal
          link={seals.handelsverband.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'handelsverband' })}
          alt="handelsverband"
        />
      )}
      {seals.ecommerce.enabled && (
        <Seal
          link={seals.ecommerce.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'ecommerce' })}
          alt="ecommerce"
        />
      )}
      {seals.oeonline.enabled && (
        <Seal
          link={seals.oeonline.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'oeonline' })}
          alt="oeonline"
        />
      )}
      {seals.dqs.enabled && (
        <Seal
          link={seals.dqs.url}
          imageSrc={images.seals.getSealImage({ language, sealName: 'dqs' })}
          alt="dqs"
        />
      )}
    </Box>
  );
};
